import { redirect } from 'react-router-dom'

import { FlowType } from '@cash-web/protos/squareup/cash/plasma/flows/FlowProto.pb'
import { JourneyRoute, LoaderFunctionArgsWithContext } from '@cash-web/shared-journey-util-main'

const unsupportedFlowTypes = [
  FlowType.BORROW_ONBOARDING,
  FlowType.PREPURCHASE_UPGRADE,
  FlowType.BUSINESS_ACCOUNT_CREATION, // https://block.atlassian.net/browse/CASHW-3742
  FlowType.CLOSE_MONEY_POOL,
  FlowType.CREATE_OR_EDIT_RECURRING_PAYMENT,
  FlowType.INITIATE_CLAIM,
  FlowType.VIEW_AP_PAYMENT_PLAN_FLOW,
  FlowType.VIEW_PAYMENT_PLAN_FLOW, // https://block.atlassian.net/browse/CASHW-3741
  'LS_ViewBorrowLimitHub', // does not exist on FlowType proto
  'P2P_REPORT_SCAM', // does not exist on FlowType proto
  'BENEFITS_HUB_NAVIGATION_FLOW', // does not exist on FlowType proto
  'INITIATE_DISPUTE_CLAIM', // does not exist on FlowType proto
]

function redirectLoader(type: string) {
  return ({ request }: LoaderFunctionArgsWithContext) => {
    const url = new URL(request.url)
    const clientRouteUrl = `https://internal.cash.app${url.pathname}${url.search}`
    const deepLinkPath = `/f/${type}${url.search}`
    const params = new URLSearchParams({
      clientRouteUrl,
      deepLinkPath,
    })

    throw redirect(`/not-found?${params.toString()}`)
  }
}

export const unsupportedFlowRoutes = unsupportedFlowTypes.flatMap(type => [
  {
    id: `flow-unsupported-${type}`,
    trackingName: `Flow Unsupported ${type}`,
    path: `dl/flow/${type}`,
    handle: { unsupported: true },
    loader: redirectLoader(type),
  },
  {
    id: `flow-type-unsupported-${type}`,
    trackingName: `Flow Type Unsupported ${type}`,
    path: `dl/flow/type/${type}`,
    handle: { unsupported: true },
    loader: redirectLoader(type),
  },
]) satisfies JourneyRoute[]
